import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgUltimateWifi = props => _jsx("svg", _objectSpread(_objectSpread({
  width: 20,
  height: 14,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 12a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm0-4c1.436 0 2.695.757 3.4 1.893l-.732.733a3 3 0 0 0-5.336 0L6.6 9.893A3.997 3.997 0 0 1 10 8Zm0-4a7.985 7.985 0 0 1 6.267 3.027l-.712.712A6.989 6.989 0 0 0 10 5a6.989 6.989 0 0 0-5.554 2.74l-.713-.713A7.985 7.985 0 0 1 10 4Zm0-4c3.643 0 6.907 1.623 9.108 4.186l-.71.71A10.976 10.976 0 0 0 10 1C6.633 1 3.62 2.513 1.602 4.896l-.71-.71A11.973 11.973 0 0 1 10 0Z",
    fill: props.color || "#58595B"
  })
}));
export default SvgUltimateWifi;